import React, { Component } from 'react';
import { Button, message } from 'antd';
import FilterBasic from '../../basicElement/FilterBasic';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import TableC from '../../basicElement/TableC';
import moment from 'moment';

const yearMonthFormat = 'YYYY-MM';

let markDate = {};
let changeTitle = 'false';
class Filter extends Component {
    render() {
        const { ...rest } = this.props;
        const filters = [{
            name: '统计月份',
            key: 'date',
            type: 'monthPicker',
            typeProperty: {
                allowClear: false,
            }
        }];
        return (
            <FilterBasic filters={filters} {...rest} />
        );
    }
}

class PositionCrcSecondPoint extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            loading: false,
            sortParams: {},
            searchParams: {},
            curParams: {},
            pagination: {
                pageSize: 10,
                current: 1,
            },
        }
    }

    componentDidMount() {
        this.queryEffectiveDate();
    }

    queryEffectiveDate = () => {
        dictCache.getDict('EFFECTIVE_DATE', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.home.queryEffectiveDate,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            const { month, year } = res;
            const { searchParams } = this.state;
            const date = `${year}-${month < 10 ? `0${month}` : month}`;
            searchParams.date = date;
            markDate =  searchParams.date;
            this.setState({
                searchParams,
                curParams: {...searchParams},
            }, () => {
                this.loadData();
            });
        });
    }

    loadData = () => {
        changeTitle = 'true';
        const { sortParams, curParams, pagination, searchParams} = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.dashboard.queryPositionCrcSecondPoint,
            data: {
                offset: current,
                limit: pageSize,
                ...sortParams,
                ...curParams,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                pagination.total = totalCount;
                this.setState({
                    loading: false,
                    data: datas,
                    pagination,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    search = () => {
        const { pagination, searchParams } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            curParams: {
                ...searchParams,
            },
        }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { activeKey, sortParams, curParams} = this.state;
        const type = 'POSITION_CRC_SECOND_POINT';
        const options = {
            method: 'POST',
            url: API_URL.dashboard.exportInvAreaByCRC,
            data: {
                ...sortParams,
                ...curParams,
                offset: 1,
                type,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
            },
        };
        $.sendRequest(options);
    }

    addToDownloadSite = (searchArray, url, type) => {
        const options = {
            method: 'POST',
            url: API_URL.common.startAsynchronousExport,
            data: { type },
            dataType: 'json',
            doneResult: (res) => {
                const { asynchronousExportId } = res;
                const params = { ...searchArray, asynchronousExportId }
                const options = {
                    method: 'POST',
                    url,
                    data: params,
                    dataType: 'json',
                    doneResult: res => {
                        message.success(res.success);
                    },
                };
                $.sendRequest(options);
            },
        };
        $.sendRequest(options);
    }

    handleFilterChange = (searchParams) => {
        this.setState({ searchParams });
    }
    handleFilterChange22 = () => {
        //yearMonthFormat 
        //const {markDate} = this.state;
        //console.log(searchParams);
        if (changeTitle == 'true') {
            const {searchParams} = this.state;
            markDate = searchParams.date;
            changeTitle = 'false';
        }
        //const {date} = markDate || {};
        // console.log('markDate = ' + markDate);
        // console.log('markDate.date = ' + markDate.date);
        //console.log(date);
        //const startValue = moment(date).add(-11,'M').format(yearMonthFormat);//moment().format(yearFormat)

        const monthMap = new Map([
            [moment(markDate).add(-11,'M').format(yearMonthFormat), 'firstData'],    
            [moment(markDate).add(-10,'M').format(yearMonthFormat), 'secondData'], 
            [moment(markDate).add(-9,'M').format(yearMonthFormat), 'thirdData'], 
            [moment(markDate).add(-8,'M').format(yearMonthFormat), 'fourthData'], 
            [moment(markDate).add(-7,'M').format(yearMonthFormat), 'fifthData'], 
            [moment(markDate).add(-6,'M').format(yearMonthFormat), 'sixthData'], 
            [moment(markDate).add(-5,'M').format(yearMonthFormat), 'seventhData'], 
            [moment(markDate).add(-4,'M').format(yearMonthFormat), 'eighthData'], 
            [moment(markDate).add(-3,'M').format(yearMonthFormat), 'ninthData'],
            [moment(markDate).add(-2,'M').format(yearMonthFormat), 'tenthData'], 
            [moment(markDate).add(-1,'M').format(yearMonthFormat), 'eleventhData'], 
            [moment(markDate).format(yearMonthFormat), 'twelfthData'],
            ['平均分', 'avgData']]);
        
        const mymap = [];
        for (let [key, value] of monthMap) {
            mymap.push({
                title: `${key}`,
                dataIndex: `${value}`,
                dataIndex: `${value}`,
                width: 70,
            });
        }
        return mymap;
    }
    

    getColumns = () => {
        const columns = [{
            title: '人员工号',
            dataIndex: 'employeeCode',
            key: 'employeeCode',
            fixed: 'left',
            width: 80,
        }, {
            title: '人员姓名',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            fixed: 'left',
            width: 100,
        }, {
            title: '区域',
            dataIndex: 'areaName',
            key: 'areaName',
            width: 80,
        }, {
            title: '城市',
            dataIndex: 'cityName',
            key: 'cityName',
            width: 80,
        }, {
            title: '主管领导工号',
            dataIndex: 'leaderName',
            key: 'leaderName',
            width: 100,
        }, {
            title: '主管领导姓名',
            dataIndex: 'leaderCode',
            key: 'leaderCode',
            width: 100,
        }, {
            title: `CRC绩效得分（总分）`,
            children:this.handleFilterChange22()
        }, {
            title: '排名',
            dataIndex: 'rank',
            key: 'rank',
            width: 80,
            fixed: 'right',
        }];
        return columns;
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    render() {
        const { exportable } = this.props;
        const { data, loading, pagination, searchParams, sortParams } = this.state;
        return (
            <div>
                <div className="reportTitle">{this.props.title}</div>
                <Filter
                    search={this.search}
                    params={searchParams}
                    onChange={this.handleFilterChange}
                    buttons={[
                        exportable ?
                            <Button key="export" type="primary" onClick={this.export} style={{marginLeft: 8}}>导出</Button>
                        :
                            <Button key="export" disabled={true} style={{marginLeft: 8}}>导出4444</Button>
                    ]}
                />
                {/* <div style={{marginTop: -20, marginBottom: 4, color: '#ffa500'}}>注：由于数据量过大，页面仅展示其中一个项目一个中心的数据，请导出后查看完整数据</div> */}
                <TableC
                    data={data}
                    scrollY={500}
                    loading={loading}
                    sortParams={sortParams}
                    columns={this.getColumns()}
                    className="visitNum"
                    pagination={pagination}
                    onChange={this.handleTableChange}
                />
            </div>
        );
    }
}

export default PositionCrcSecondPoint;


// WEBPACK FOOTER //
// ./src/components/homePage/statement/positionCrcSecondPoint.js